module.exports = __webpack_public_path__ + "assets/img/title-0fef8bdd.png";